<template>
	<div class="Bar">
		<div class="echarts-view" v-for="(item , index) of echartsOptions" :key="index"
			:id="'EchartsBar'+item.numCharts"></div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			echartsOptions: {
				type: Array,
				default: () => {
					return []
				}
			},
			QuarterAmount: {
				type: Object,
				default: () => {
					return {

					}
				}
			},
			num: {
				type: Number,
				default: 1
			}
		},
		data() {
			return {
				numCharts: this.num
			}
		},
		created() {},
		mounted() {

		},
		activated() {},
		updated() {},
		methods: {
			//格式化小数位
			fixedVal(val, num = 1) {
				return (val / 10000).toFixed(num);
			},
			BarInit() {
				this.echartsOptions.forEach((item, index) => {
					console.log(item);
					var myChart = this.$MyEcharts.init(document.getElementById("EchartsBar" + item.numCharts),
						'shine');
					// 调用showLoading方法
					myChart.showLoading({
						text: 'loading',
						color: '#c23531',
						textColor: '#000',
						maskColor: 'rgba(255, 255, 255, 0.2)',
						zlevel: 0,
					});
					var option = {
						color: item.color,
						title: {
							text: "",
							textStyle: {
								fontSize: 16,
								padding: "10px"
							}
						},
						legend: item.legend,
						toolbox: item.toolbox,
						grid: item.grid,
						tooltip: {},
						xAxis: {
							data: item.xAxisData
						},
						yAxis: item.yAxis,
						series: item.series
					};
					myChart.hideLoading();
					myChart.setOption(option, true);
					window.addEventListener("resize", function() {
						myChart.resize();
					});

				})
			},
		},
		computed: {},
		watch: {
			QuarterAmount: {
				handler(newQuarterAmount, oldQuarterAmount) {
					if (newQuarterAmount) {
						console.log(newQuarterAmount, 'newQuarterAmount');
						if (newQuarterAmount.type == 'SalesAmount') {
							let newQuarterAmountData = [
								this.fixedVal(newQuarterAmount.FirstQuarterAmount),
								this.fixedVal(newQuarterAmount.SecondQuarterAmount),
								this.fixedVal(newQuarterAmount.ThirdQuarterAmount),
								this.fixedVal(newQuarterAmount.FourthQuarterAmount)
							];
							this.echartsOptions[0].series[0].data = newQuarterAmountData
						}
						if (newQuarterAmount.type == 'QuotaSummary') {
							let newQuarterAmountData = [
								this.fixedVal(newQuarterAmount.data.FirstQuarter.Amount),
								this.fixedVal(newQuarterAmount.data.SecondQuarter.Amount),
								this.fixedVal(newQuarterAmount.data.ThirdQuarter.Amount),
								this.fixedVal(newQuarterAmount.data.FourthQuarter.Amount),
							];
							let newQuarterQuotaData = [
								this.fixedVal(newQuarterAmount.data.FirstQuarter.Quota),
								this.fixedVal(newQuarterAmount.data.SecondQuarter.Quota),
								this.fixedVal(newQuarterAmount.data.ThirdQuarter.Quota),
								this.fixedVal(newQuarterAmount.data.FourthQuarter.Quota),
							];
							this.echartsOptions[0].series[0].data = newQuarterAmountData
							this.echartsOptions[0].series[1].data = newQuarterQuotaData
						}
						// 指标中心中间部分图表数据
						if (newQuarterAmount.type == 'PurchaseQuotaInfo') {
							let newQuarterAmountData = [
								newQuarterAmount.FirstQuarter.QuarterYTD,
								newQuarterAmount.SecondQuarter.QuarterYTD,
								newQuarterAmount.ThirdQuarter.QuarterYTD,
								newQuarterAmount.FourthQuarter.QuarterYTD,
							];
							let newQuarterQuotaData = [
								newQuarterAmount.FirstQuarter.QuarterBP,
								newQuarterAmount.SecondQuarter.QuarterBP,
								newQuarterAmount.ThirdQuarter.QuarterBP,
								newQuarterAmount.FourthQuarter.QuarterBP,
							];
							this.echartsOptions[0].series[0].data = newQuarterAmountData
							this.echartsOptions[0].series[1].data = newQuarterQuotaData
						}

						// 实例化echarts对象
						this.BarInit();
					}
				},
				immediate: true,
				deep: true
			}
		}
	}
</script>
<style lang="less">
	.Bar {
		height: 400px !important;

		.echarts-view {
			height: 400px !important;
		}
	}
</style>
